enum Position {
    First = 1,
    Second = 2,
    Third = 3,
}

export default Position;
